import React from 'react'
import styled from '@emotion/styled'
import ScrollContainer from 'react-indiana-drag-scroll'
import { Box } from 'theme-ui'
import theme from '../../../gatsby-plugin-theme-ui/index'
import { mobile, smDesktop, tablet } from '../../shared'
import { css } from '@emotion/core'

const CarouselContainer = styled(ScrollContainer)`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  overflow-x: scroll;

  /* width */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    margin-tp: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${p => p.theme.colors.lighterGray};

    margin: 0em 8em;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    margin: 0em 8em;
    background: black;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    margin: 0em 8em;
    background: gray;
  }

  ${smDesktop(css`
    ::-webkit-scrollbar-track {
      margin: 0em 1em;
    }
    ::-webkit-scrollbar-thumb:hover {
      margin: 0em 1em;
      background: gray;
    }
    ::-webkit-scrollbar-thumb {
      margin: 0em 1em;
      background: black;
    }
    ::-webkit-scrollbar-thumb:hover {
      margin: 0em 1em;
      background: gray;
    }
  `)}

  ${mobile(css`
    ::-webkit-scrollbar-track {
      margin: 0em 1em;
    }
    ::-webkit-scrollbar-thumb:hover {
      margin: 0em 1em;
    }
    ::-webkit-scrollbar-thumb {
      margin: 0em 1em;
    }
    ::-webkit-scrollbar-thumb:hover {
      margin: 0em 1em;
    }
  `)}
`

const CarouselSlider = props => {
  const { children } = props

  return (
    <Box>
      <CarouselContainer
        {...props}
        veritcalScroll={false}
        hideScrollbars={false}
      >
        {children}
      </CarouselContainer>
    </Box>
  )
}

export default CarouselSlider
